import axios from "axios";
import {Badge} from "@capawesome/capacitor-badge";

const sidebars = {
    state: {
        showNotifications: false,
        showSettings: false,
        showDocumentsCreateForm: false,
        showDocumentsEditForm: false,
	    showContractsEditForm: false,
        showPersonalDocumentsCreateForm: false,
        showPersonalDocumentsEditForm: false,
        showCardsCreateForm: false,
        showCardsEditForm: false,
        showProtocolDetail: false,
        showPortfolioDetail: false,
        showOnlineServicesSidebar: false,
        backToNotifications: false,
        backToOfflineCards: false,
        showPropertyCreateForm: false,
        showPropertyEditForm: false,
        showReceiptsCreateForm: false,
        showReceiptsEditForm: false,
        receiptEditData: null,
        documentFormType: 'document',
        showOfflineCardsList: false,
    },
    mutations: {
		SHOW_NOTIFICATIONS(state) {
			state.showNotifications = true;
		},
        TOGGLE_NOTIFICATIONS(state) {
            state.showNotifications = !state.showNotifications;
        },
        TOGGLE_SETTINGS(state) {
            state.showSettings = !state.showSettings;
        },
        TOGGLE_DOCUMENTS_CREATE_FORM(state) {
            state.showDocumentsCreateForm = !state.showDocumentsCreateForm;
        },
        HIDE_DOCUMENTS_CREATE_FORM(state) {
            state.showDocumentsCreateForm = false;
            state.documentFormType = 'document';
        },
        HIDE_DOCUMENTS_EDIT_FORM(state){
            state.showDocumentsEditForm = false;
        },
        HIDE_CONTRACTS_EDIT_FORM(state){
            state.showContractsEditForm = false;
        },
        HIDE_PERSONAL_DOCUMENTS_EDIT_FORM(state){
            state.showPersonalDocumentsEditForm = false;
        },
        SHOW_PERSONAL_DOCUMENTS_EDIT_FORM(state, data){
            state.showPersonalDocumentsEditForm = data;
        },
        SHOW_DOCUMENTS_EDIT_FORM(state, data){
            state.showDocumentsEditForm = data;
        },
	    SHOW_CONTRACTS_EDIT_FORM(state, data){
		    state.showContractsEditForm = data;
	    },
        SHOW_PERSONAL_DOCUMENTS_CREATE_FORM(state){
            state.showPersonalDocumentsCreateForm = true;
        },
        HIDE_PERSONAL_DOCUMENTS_CREATE_FORM(state){
            state.showPersonalDocumentsCreateForm = false;
        },
        TOGGLE_PERSONAL_DOCUMENTS_CREATE_FORM(state){
            state.showPersonalDocumentsCreateForm = !state.showPersonalDocumentsCreateForm;
        },
        SHOW_CARDS_CREATE_FORM(state){
            state.showCardsCreateForm = true;
        },
        TOGGLE_CARDS_CREATE_FORM(state){
            state.showCardsCreateForm = !state.showCardsCreateForm;
        },
        SHOW_CARDS_EDIT_FORM(state, data){
            state.showCardsEditForm = data;
        },
        HIDE_CARDS_EDIT_FORM(state){
            state.showCardsEditForm = false;
        },
        SHOW_OFFLINE_CARDS_LIST(state){
            state.showOfflineCardsList = true;
        },
        HIDE_OFFLINE_CARDS_LIST(state){
            state.showOfflineCardsList = false;
        },
        SHOW_PROTOCOL_DETAIL(state, data){
            state.showProtocolDetail = data;
        },
        HIDE_PROTOCOL_DETAIL(state){
            state.showProtocolDetail = false;
        },
        SHOW_PORTFOLIO_DETAIL(state, data){
            state.showPortfolioDetail = data;
        },
        HIDE_PORTFOLIO_DETAIL(state){
            state.showPortfolioDetail = false;
        },
        SHOW_ONLINE_SERVICES_SIDEBAR(state, data){
            state.showOnlineServicesSidebar = data;
        },
        SET_BACK_TO_NOTIFICATIONS(state, data){
            state.backToNotifications = data;
        },
        SET_BACK_TO_OFFLINE_CARDS(state, data){
            state.backToOfflineCards = data;
        },
        SHOW_PROPERTY_CREATE_FORM(state){
            state.showPropertyCreateForm = true;
        },
        HIDE_PROPERTY_CREATE_FORM(state){
            state.showPropertyCreateForm = false;
        },
        SHOW_PROPERTY_EDIT_FORM(state, data){
            state.showPropertyEditForm = data;
        },
        HIDE_PROPERTY_EDIT_FORM(state){
            state.showPropertyEditForm = false;
        },
        SHOW_DEBT_CREATE_FORM(state){
            state.documentFormType = 'debt';
            state.showDocumentsCreateForm = true;
        },
        SHOW_PAYMENT_CREATE_FORM(state){
            state.documentFormType = 'payment';
            state.showDocumentsCreateForm = true;
        },
        TOGGLE_RECEIPTS_CREATE_FORM(state) {
            state.showReceiptsCreateForm = !state.showReceiptsCreateForm;
        },
        HIDE_RECEIPTS_CREATE_FORM(state) {
            state.showReceiptsCreateForm = false;
        },
        SHOW_RECEIPTS_EDIT_FORM(state, data) {
            state.receiptEditData = data;
            state.showReceiptsEditForm = true;
        },
        HIDE_RECEIPTS_EDIT_FORM(state) {
            state.showReceiptsEditForm = false;
            state.receiptEditData = null;
        }
    },
    actions: {
        toggleNotificationsSidebar(context){
            if (!context.state.showNotifications){
                if (context.rootState.auth.user.not_shown_notifications_count){
                    axios.get('/api/notification/mark-as-shown').then(() => {
                        context.commit('CLEAR_NOT_SHOWN_NOTIFICATIONS');
                    });
                }

                if (context.rootState.app.native){
                    Badge.clear();
                }
            }

            context.state.showNotifications = !context.state.showNotifications;
        },
        closeSidebars(context) {
	        for (const [key] of Object.entries(context.state)) {
                if(key !== 'backToNotifications' && key !== 'backToOfflineCards'){
                    context.state[key] = false;
                }
	        }
        },
    }
};

export default sidebars;